import React from 'react'
import '../App.css';
import BodyContactos from '../components/BodyContactos';
function Contactos() {
  return (
    <div class="contactos">
      <BodyContactos />
    </div>
  )
}

export default Contactos
